export const FEIN_LENGTH = 9;
export const FEIN_MASK = '##-#######';
//# sourceMappingURL=fein.js.map